import { FormInputExtendedProps } from "@dirootie-web/components-types";
import { Field, useField } from "formik";
import { CustomInput, Form } from "taltech-styleguide";
import { FeedbackMessage } from "./FeedbackMessage";

export const InputCheckbox = ({
  id,
  disabled,
  ...props
}: Partial<FormInputExtendedProps>) => {
  const [field, meta, handlers] = useField(id!);
  return (
    <Form.Group
      className={`${props.elementClass} mt-2 d-flex justify-content-end align-items-center flex-row-reverse`}
    >
      {props.label && (
        <Form.Label className={"mx-2 ebd-checkbox-label"}>
          {props.label}
        </Form.Label>
      )}
      <Field
        name={id}
        component={CustomInput}
        disabled={disabled}
        renderAs="checkbox"
        checked={field.value}
      />
      <FeedbackMessage fieldId={id!}></FeedbackMessage>
    </Form.Group>
  );
};
